<template>
  <div>
    <v-row class="mt-0">
      <v-col cols="12" class="pb-0">
        <!-- Reload button -->
        <v-btn class="primary" small @click.stop="getCampaigns()">
          <v-icon left>
            mdi-cached
          </v-icon>
          Reload
        </v-btn>
        <!-- <v-btn @click="resetFilter" class="ml-2"  style="float: right">Reset Filters</v-btn> -->
        <v-select
          style="max-width:200px;float:right;"
          :items="defaultYears"
          label="Year"
          v-model="selectedFilter.year"
          outlined
          dense
          hide-details
          @change="getCampaigns()"
        ></v-select>
      </v-col>
    </v-row>
    <div class="pt-5">
      <average-boxes :totalValues="totalValues" />
    </div>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          <v-row class="filter-area">
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="AM"
                item-value="id"
                item-text="name"
                label="AM"
                v-model="selectedFilter.AM"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2" lg="2">
              <v-autocomplete
                :items="CC"
                item-value="id"
                item-text="name"
                label="CC"
                v-model="selectedFilter.CC"
                hide-details
                outlined
                dense
                @change="searchFilter"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3">
              <v-card-title class="pt-0">
                <v-text-field class="pt-0" v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
            </v-col>
          </v-row>
        </v-card-title>
      </v-col>
    </v-row>
    <!-- <v-row class="mb-0">
      <v-col cols="12" sm="6" md="6" lg="6">
      </v-col>
    </v-row> -->
    <v-data-table
      ref="TimelineSummaryTable"
      :headers="headers"
      :search="filter"
      :items="filteredItems"
      @current-items="currentItems"
      :items-per-page="15"
      class="timeline-summary-table elevation-1">
      <template v-slot:[`item.activating`]="{ item }">
        <v-layout row class="text-center">
          <v-flex class="rating-num">
            <v-menu
              color="#363636"
              dark
              max-height="500px"
              :close-on-content-click="false"
              top
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  text
                  @click="getSummaryDetails(item, 'activating')"
                >
                  {{item.activating}} days
                </v-btn>
              </template>
              <v-card max-width="350" min-height="100" style="text-align: left;width:300px;">
                <v-card-text>
                  <div v-if="summaryDetails.actual">
                    <menu-summary :summary="summaryDetails" />
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:[`item.pairing`]="{ item }">
        <v-layout row class="text-center">
          <v-flex class="rating-num">
            <v-menu
              color="#363636"
              dark
              max-height="500px"
              :close-on-content-click="false"
              top
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  text
                  @click="getSummaryDetails(item, 'pairing')"
                >
                  {{item.pairing}} days
                </v-btn>
              </template>
              <v-card max-width="350" min-height="120" style="text-align: left;width:300px;">
                <v-card-text>
                  <div v-if="summaryDetails.actual">
                    <menu-summary :summary="summaryDetails" />
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:[`item.cocreating`]="{ item }">
        <v-layout row class="text-center">
          <v-flex class="rating-num">
            <v-menu
              color="#363636"
              dark
              max-height="500px"
              :close-on-content-click="false"
              top
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  text
                  @click="getSummaryDetails(item, 'cocreating')"
                >
                  {{item.cocreating}} days
                </v-btn>
              </template>
              <v-card max-width="350" min-height="140" style="text-align: left;width:300px;">
                <v-card-text>
                  <div v-if="summaryDetails.actual">
                    <menu-summary :summary="summaryDetails" />
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:[`item.complete`]="{ item }">
        <v-layout row class="text-center">
          <v-flex class="rating-num">
            <v-menu
              color="#363636"
              dark
              max-height="500px"
              :close-on-content-click="false"
              top
              offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    text
                    @click="getSummaryDetails(item, 'complete')"
                  >
                    {{item.complete}} days
                  </v-btn>
                </template>
                <v-card max-width="350" min-height="100" style="text-align: left;width:300px;">
                  <v-card-text>
                    <div v-if="summaryDetails.actual">
                      <menu-summary :summary="summaryDetails" />
                    </div>
                  </v-card-text>
                </v-card>
              </v-menu>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:[`item.totalDuration`]="{ item }">
        <v-layout row class="text-center">
          <v-flex class="rating-num">
            <v-btn
              color="secondary"
              v-bind="attrs"
              v-on="on"
              text
            >
              {{item.totalDuration}} days
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <td class="text-center" style="width:100px">
          <v-btn
            small
            color="secondary"
            target="_blank"
            :to="'/campaigns/timeline?campaignID='+item.campaignID"
          >
            <v-icon small>remove_red_eye</v-icon> View Timeline
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </div>
</template>
<script>
import config from '@/config';
import timelineConfig from '../config';
// import campaignHelper from '../campaignHelper';
import userAPIs from '../../../User/userAPIs';
import Loading from 'vue-loading-overlay';
import AverageBoxes from './AverageBoxes'
import MenuSummary from './MenuSummary'
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'CogsSummaryDataTable',
  props: ['refresh'],
  components: {
    AverageBoxes,
    MenuSummary,
    Loading
  },
  data() {
    return {
      headers: timelineConfig.summaryTableHeaders,
      summaries: timelineConfig.defaultSummaries,
      defaultYears: ['All', 2022, 2023, 2024],
      items: [],
      filter: '',
      filteredItems: [],
      AM: [],
      CC: [],
      isLoading: false,
      selectedFilter: {
        AM: '',
        CC: '',
        year: 2024
      },
      totalValues: {
        activating: 0,
        pairing: 0,
        cocreating: 0,
        complete: 0,
        duration: 0
      },
      summaryDetails: {}
    }
  },
  watch: {
    refresh(value) {
      if (value) this.init()
    }
  },
  computed: {
    ...mapState({
      timelineStages: state => state.campaignTimeline.timelineStages,
      timelineSummary: state => state.campaignTimeline.timelineSummary,
      actualDays: state => state.campaignTimeline.actualDays
    }),
    ...mapGetters('campaignTimeline', [
      'getActivatingActualDays',
      'getPairingActualDays',
      'getCocreatingActualDays',
      'getCompleteActualDays'
    ]),
    isAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW
    }
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.isLoading = true
      await this.getUsers()
      await this.getCampaigns()
    },
    async getCampaigns() {
      this.isLoading = true
      await this.$store.dispatch('campaignTimeline/getCampaignTimelineSummary', {
        filters: {
          year: this.selectedFilter.year
        }
      })
      if (this.timelineSummary) {
        this.items = Object.assign([], this.timelineSummary)
        this.beautifyData()
        this.searchFilter()
      }
      this.isLoading = false
    },
    beautifyData() {
      this.items = this.items.filter(item => item.campaign)
      this.items = this.items.map(item => {
        if (item.campaign) {
          item.campaignID = item.campaign.id
          item.name = item.campaign.name || ''
          item.assignedTo = item.campaign.assignedTo || []
        }
        item.AM = this.AM.filter(am => item.campaign.assignedTo && item.campaign.assignedTo.includes(am.id)).map(am => am.name).join(', ')
        item.CC = this.CC.filter(cc => item.campaign.assignedTo && item.campaign.assignedTo.includes(cc.id)).map(cc => cc.name).join(', ')
        if (item.actualNumOfDaysPerStage) {
          const actualDays = item.actualNumOfDaysPerStage
          item.activating = actualDays.activating ? actualDays.activating.days : 0
          item.pairing = actualDays.pairing ? actualDays.pairing.days : 0
          item.cocreating = actualDays.cocreating ? actualDays.cocreating.days : 0
          item.complete = actualDays.complete ? actualDays.complete.days : 0
          item.totalDuration = item.activating + item.pairing + item.cocreating + item.complete
        }
        return item
      })
    },
    async getUsers() {
      try {
        let response = null
        // Get all AM by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        if (response) {
          this.AM = response.users
          this.AM = this.AM.map(am => {
            am.name = `${am.firstName} ${am.lastName}`
            return am
          })
        }
        this.AM.unshift({id: '', name: 'All Team'})
        // Get all CC by role
        response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
        if (response) {
          this.CC = response.users
          this.CC = this.CC.map(cc => {
            cc.name = `${cc.firstName} ${cc.lastName}`
            return cc
          })
          this.CC.unshift({id: '', name: 'All Team'})
        }
      } catch (error) {
        // Request failed.
        console.log('error', error);
        return false
      }
    },
    resetFilter() {
      this.selectedFilter = {
        campaignType: '',
        AM: '',
        CC: '',
        year: '2024'
      }
      this.filter = ''
      this.searchFilter()
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => (item.assignedTo && item.assignedTo.includes(this.selectedFilter.AM)))
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(item => (item.assignedTo && item.assignedTo.includes(this.selectedFilter.CC)))
      }
      this.calAvgSummary()
    },
    formatDecimal(value) {
      return parseFloat(value).toFixed(2)
    },
    calAvgSummary(customItems = []) {
      this.totalValues = {
        activating: 0,
        pairing: 0,
        cocreating: 0,
        complete: 0
      }
      let calcItems = []
      if (customItems.length) {
        calcItems = Object.assign([], customItems)
      } else {
        calcItems = Object.assign([], this.filteredItems)
      }
      let totalItems = calcItems.length
      if (!totalItems) return // if no results, skip calc
      let activating = 0
      let pairing = 0
      let cocreating = 0
      let complete = 0
      calcItems.map(f => {
        if (f.activating) activating += parseInt(f.activating || 0)
        if (f.pairing) pairing += parseInt(f.pairing || 0)
        if (f.cocreating) cocreating += parseInt(f.cocreating || 0)
        if (f.complete) complete += parseInt(f.complete || 0)
        return f
      })
      let totalDuration = activating + pairing + cocreating + complete
      let avgDuration = Number(totalDuration / customItems.length)
      // set total counts
      let totalActivating = calcItems.filter(c => c.activating).length
      let totalPairing = calcItems.filter(c => c.pairing).length
      let totalCocreating = calcItems.filter(c => c.cocreating).length
      let totalComplete = calcItems.filter(c => c.complete).length
      // calc avg values
      this.totalValues.activating = Math.round(activating / totalActivating, 0)
      this.totalValues.pairing = Math.round(pairing / totalPairing, 0)
      this.totalValues.cocreating = Math.round(cocreating / totalCocreating, 0)
      this.totalValues.complete = Math.round(complete / totalComplete, 0)
      this.totalValues.duration = Math.round(avgDuration, 0)
    },
    async getSummaryDetails(item, type) {
      await this.$store.dispatch('campaignTimeline/getActualDays', {
        campaignID: item.campaignID,
        type
      })
      let result = null
      switch (type) {
        case this.timelineStages.activating:
          result = this.getActivatingActualDays(this.summaries[type], this.actualDays)
          break;
        case this.timelineStages.pairing:
          result = this.getPairingActualDays(this.summaries[type], this.actualDays)
          break;
        case this.timelineStages.cocreating:
          result = this.getCocreatingActualDays(this.summaries[type], this.actualDays)
          break;
        case this.timelineStages.complete:
          result = this.getCompleteActualDays(this.summaries[type], this.actualDays)
          break;
        default:
          break;
      }
      this.summaryDetails = Object.assign({}, result)
    },
    currentItems() {
      this.$nextTick(() => {
        this.calAvgSummary(this.$refs.TimelineSummaryTable.$children[0].filteredItems)
      });
    }
  }
}
</script>
<style scoped>
  .summary-chip {
    font-size: 14px!important;
  }
  .filter-area {
    justify-content: right;
  }
  .rating-num {
    font-size: 15px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?972418e0